import { javaApiInstance } from 'utils/request'
import parseError from 'helpers/parseServerError'
import { annotateSurpriseBoxError } from 'pages/SurpriseBox/errorMessages'

const BASE_PATH = '/admin/v1/surprise-box/promotions'

const handle = (defaultMessage) => (error) => {
  parseError(annotateSurpriseBoxError(error), defaultMessage)
  throw error
}

export const listPromotions = ({ status, page = 1, perPage = 50 } = {}) => {
  const params = { page, per_page: perPage }
  if (status) params.status = status

  return javaApiInstance
    .get(BASE_PATH, { params })
    .catch(handle('Cannot get surprise box promotions'))
}

export const getPromotion = (id) => {
  return javaApiInstance
    .get(`${BASE_PATH}/${id}`)
    .catch(handle('Cannot get surprise box promotion'))
}

export const createPromotion = (values) => {
  return javaApiInstance
    .post(BASE_PATH, values)
    .catch(handle('Cannot create surprise box promotion'))
}

export const updatePromotion = (id, values) => {
  return javaApiInstance
    .put(`${BASE_PATH}/${id}`, values)
    .catch(handle('Cannot update surprise box promotion'))
}

export const activatePromotion = (id) => {
  return javaApiInstance
    .post(`${BASE_PATH}/${id}/activate`)
    .catch(handle('Cannot activate surprise box promotion'))
}

export const deactivatePromotion = (id) => {
  return javaApiInstance
    .post(`${BASE_PATH}/${id}/deactivate`)
    .catch(handle('Cannot deactivate surprise box promotion'))
}

export const cancelPromotion = (id) => {
  return javaApiInstance
    .post(`${BASE_PATH}/${id}/cancel`)
    .catch(handle('Cannot cancel surprise box promotion'))
}
